import React from 'react'
import {motion} from 'framer-motion'
import {AppWrap, MotionWrap} from '../../wrapper'
import './Services.scss'

import {services} from "../../data/data";

const Services = () => {

    return (
        <>
            <h2 className='head-text'>
                Une bonne<span> Stratégie</span><br/>
                de <span>Communication</span><br/>
                Fait la<span> différence !</span>
            </h2>

            <div className='app__profiles'>
                {services.map((services, index) => (
                    <div key={services.name + index}>
                        <motion.div
                            whileInView={{opacity: 1}}
                            whileHover={{scale: 1.1}}
                            transition={{duration: 0.5, type: 'tween'}}
                            className='app__profile-item'
                        >
                            {services.img && <img src={services.img} alt=""/>}
                            <h2 className='bold-text' style={{marginTop: 20}}>{services.name}</h2>
                            <p className='p-text' style={{marginTop: 10}}>{services.description}</p>
                        </motion.div>
                    </div>
                ))}
            </div>
        </>
    )
}

export default AppWrap(
    MotionWrap(Services, 'app__services'),
    'services',
    "app__primarybg"
)
